import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var propTypes = {
  /**
   specifies the button category - one of [primary, secondary, danger, outline, link, icon]
  */
  category: PropTypes.oneOf(['primary', 'secondary', 'danger', 'outline', 'success', 'link', 'icon']),

  /**
   specifies the button size - one of [small, full]
  */
  size: PropTypes.oneOf(['small', 'full']),

  /**
   button type - one of [button, submit, reset]
  */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),

  /**
  specifies an Icon to appear on the left of the title (Icon or Spinner)
  */
  icon: PropTypes.node,

  /**
   additional style class(es) for the button
  */
  className: PropTypes.string,

  /**
    titles are passed in as children
  */
  children: PropTypes.node,

  /**
   onClick event for button
  */
  onClick: PropTypes.func,

  /**
   is the button active?
  */
  active: PropTypes.bool,

  /**
   is the button disabled?
  */
  disabled: PropTypes.bool,

  /**
   is the button focused?
  */
  focus: PropTypes.bool,

  /**
   is the button hovered?
  */
  hover: PropTypes.bool,

  /**
   ARIA role
  */
  role: PropTypes.string,

  /**
   is the button placed inside listgroup?
  */
  list: PropTypes.bool,

  /**
   is the button closing navigation menu?
  */
  navClose: PropTypes.bool
};
var defaultProps = {
  category: undefined,
  size: undefined,
  icon: undefined,
  className: undefined,
  children: undefined,
  type: 'button',
  onClick: function onClick() {},
  active: false,
  disabled: false,
  focus: false,
  hover: false,
  role: 'button',
  list: false,
  navClose: false
};

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "focus",
    value: function focus() {
      this.button.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.button.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this = this;

      var _this$props = this.props,
          category = _this$props.category,
          size = _this$props.size,
          icon = _this$props.icon,
          className = _this$props.className,
          children = _this$props.children,
          type = _this$props.type,
          role = _this$props.role,
          _onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          active = _this$props.active,
          hover = _this$props.hover,
          focus = _this$props.focus,
          list = _this$props.list,
          navClose = _this$props.navClose,
          otherProps = _objectWithoutProperties(_this$props, ["category", "size", "icon", "className", "children", "type", "role", "onClick", "disabled", "active", "hover", "focus", "list", "navClose"]);

      var categoryClass = classNames((_classNames = {}, _defineProperty(_classNames, "wds-c-button--".concat(category), category), _defineProperty(_classNames, "wds-c-button--".concat(size), size), _defineProperty(_classNames, 'wds-c-button--disabled', disabled), _defineProperty(_classNames, 'wds-c-button--active', active && !list), _defineProperty(_classNames, 'wds-c-button--hover', hover), _defineProperty(_classNames, 'wds-c-button--focus', focus), _defineProperty(_classNames, 'wds-c-button', !list), _defineProperty(_classNames, 'wds-c-list__item', list), _defineProperty(_classNames, 'wds-u-current', active && list), _classNames), className);
      return (// eslint-disable-next-line react/button-has-type
        React.createElement("button", _extends({}, !list ? {
          type: type
        } : {}, {
          className: categoryClass,
          disabled: disabled,
          role: role,
          onClick: function onClick(e) {
            return _onClick(e);
          }
        }, navClose && {
          'data-nav-close': ''
        }, otherProps, {
          ref: function ref(button) {
            _this.button = button;
          }
        }), icon, children)
      );
    }
  }]);

  return Button;
}(Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.displayName = 'Button';
export default Button;